import { FlashcardDeck, FlashcardDeckProps } from '../../domain/entities/FlashcardDeck';
import { FlashcardDeckDTO } from '../dto/FlashcardDeckDTO';

export class FlashcardDeckMapper {
  static toDTO(deck: FlashcardDeck): FlashcardDeckDTO {
    return {
      id: deck.id,
      lessonId: deck.lessonId,
      courseId: deck.courseId,
      createdBy: deck.createdBy,
      creatorRole: deck.creatorRole,
      title: deck.title,
      description: deck.description,
      cardCount: deck.cardCount,
      isAiGenerated: deck.isAiGenerated,
      isMerged: deck.isMerged,
      sourceDeckIds: deck.sourceDeckIds,
      createdAt: deck.createdAt.toISOString(),
      updatedAt: deck.updatedAt.toISOString(),
      courseName: deck.courseName,
      lessonTitle: deck.lessonTitle,
      creatorName: deck.creatorName,
      dueCardCount: deck.dueCardCount,
      masteredCount: deck.masteredCount,
      newCardCount: deck.newCardCount,
      masteryPercentage: deck.getMasteryPercentage(),
    };
  }

  static toDTOList(decks: FlashcardDeck[]): FlashcardDeckDTO[] {
    return decks.map(deck => this.toDTO(deck));
  }

  static fromDatabaseRow(row: Record<string, unknown>): FlashcardDeck {
    const r = row as {
      id: number;
      lesson_id: number | null;
      course_id: number;
      created_by: string;
      creator_role: string;
      workspace_id: number;
      title: string;
      description: string | null;
      card_count: number;
      is_ai_generated: boolean;
      is_merged: boolean;
      source_deck_ids: number[] | null;
      created_at: string;
      updated_at: string;
      course?: { subject?: { name: string } | null } | null;
      lesson?: { title: string } | null;
      creator?: { full_name: string } | null;
      due_count?: number;
      mastered_count?: number;
      new_count?: number;
    };

    const props: FlashcardDeckProps = {
      id: String(r.id),
      lessonId: r.lesson_id ? String(r.lesson_id) : null,
      courseId: String(r.course_id),
      createdBy: r.created_by,
      creatorRole: r.creator_role,
      workspaceId: String(r.workspace_id),
      title: r.title,
      description: r.description || '',
      cardCount: r.card_count,
      isAiGenerated: r.is_ai_generated,
      isMerged: r.is_merged,
      sourceDeckIds: (r.source_deck_ids || []).map(String),
      createdAt: new Date(r.created_at),
      updatedAt: new Date(r.updated_at),
      courseName: r.course?.subject?.name,
      lessonTitle: r.lesson?.title,
      creatorName: r.creator?.full_name,
      dueCardCount: r.due_count,
      masteredCount: r.mastered_count,
      newCardCount: r.new_count,
    };
    return new FlashcardDeck(props);
  }
}
